import React, { useEffect, useState } from 'react';
import { Grid, Typography } from '@mui/material';
import StockCard from '../components/StockCard';
import { PageLayout } from "../components/page-layout";
import AutoPopupMensagem from '../components/auto-popup-mensagem';
import { useAuth0 } from "@auth0/auth0-react";

const STORAGE_KEY = "portfolio";

export default function Asx() {
  const { user, isAuthenticated } = useAuth0();

  const [stocks, setStocks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [portfolio, setPortfolio] = useState([]);
  const [successMsg, setSuccessMsg] = useState("");

  // ---------- Load stocks ----------
  useEffect(() => {
    const dataUrl = "https://finance-files-servless-fabio.s3.us-east-1.amazonaws.com/stocks-au.json";

    fetch(dataUrl)
      .then((response) => {
        if (!response.ok) throw new Error("Erro ao carregar dados do S3");
        return response.json();
      })
      .then((data) => {
        setStocks(data);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Erro ao buscar dados:", error);
        setLoading(false);
      });
  }, []);

  // ---------- Load portfolio ----------
  useEffect(() => {
    if (!user?.email) return;
    const stored = JSON.parse(localStorage.getItem(`${STORAGE_KEY}_${user.email}`) || "[]");
    setPortfolio(stored);
  }, [user?.email]);

  // ---------- Add to portfolio ----------
  const addToPortfolio = (ticker) => {
    if (!user?.email) return;

    const storageKey = `${STORAGE_KEY}_${user.email}`;
    const stored = JSON.parse(localStorage.getItem(storageKey) || "[]");

    if (stored.includes(ticker)) {
      setSuccessMsg("Already in portfolio");
      setTimeout(() => setSuccessMsg(""), 2000);
      return;
    }

    const updated = [...stored, ticker];
    localStorage.setItem(storageKey, JSON.stringify(updated));
    setPortfolio(updated);

    setSuccessMsg("Added to portfolio ✓");
    setTimeout(() => setSuccessMsg(""), 2000);
  };

  if (loading) {
    return (
      <PageLayout>
        <div style={{ padding: '20px' }}>
          <Typography variant="body1">Loading ASX stocks data...</Typography>
        </div>
      </PageLayout>
    );
  }

  return (
    <PageLayout>
      <div style={{ padding: '10px 20px' }}>
        <Typography variant="h5" gutterBottom>
          ASX Stocks
        </Typography>

        <AutoPopupMensagem
          titulo="Current Screening Criteria - ASX Stocks"
          mensagem={`• Net income ≥ $10M
• Debt-to-EBITDA ≤ 2
• 10 years of profitability
• Profit margin > 5%`}
          oncePerSession={true}
          persistent="session"
          oncePersistKey="asx-filter"
        />

        {successMsg && (
          <Typography
            variant="body2"
            sx={{ color: "lightgreen", marginBottom: "8px" }}
          >
            {successMsg}
          </Typography>
        )}

        <Grid container spacing={2} justifyContent="center">
          {stocks.map((stock, index) => (
            <Grid
              item
              key={index}
              xs={12}
              sm={6}
              md={4}
              style={{ display: 'flex', justifyContent: 'center' }}
            >
              <StockCard
                stock={stock}
                isAuthenticated={isAuthenticated}
                inPortfolio={portfolio.includes(stock.financial_data.ticker)}
                onAdd={() => addToPortfolio(stock.financial_data.ticker)}
              />
            </Grid>
          ))}
        </Grid>
      </div>
    </PageLayout>
  );
}
